var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stream)?_c('video',{staticStyle:{"width":"100%"},attrs:{"autoplay":""},domProps:{"srcObject":_vm.stream}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }